import type { CertificationDocument } from './certificationDocuments';

export type CertificationUserDetails = {
  firstIssuedOn?: string;
  lastReceivedOn: string;
  expiryDate: string;
  document?: CertificationDocument;
};

export type CertificationsByAssetId =
  Record<string, CertificationUserDetails>;

export const buildDefaultCertificationDetails = (
  assetIds: string[],
  lastReceivedOn: string,
  expiryDate: string,
  includeFirstIssuedOn: boolean,
): CertificationsByAssetId => Object.fromEntries(
  assetIds.map((assetId) => [
    assetId,
    {
      ...(includeFirstIssuedOn ? { firstIssuedOn: lastReceivedOn } : {}),
      lastReceivedOn,
      expiryDate,
    },
  ]),
);
